import React, { useState } from "react";
import { CardComp, TabsComp, ModalCompAdvanceUpdate } from "../../../components";
import PageWrapper from "../modules/PageWrapper";
import LoanStatusTable from "./LoanStatusTable";
import { useNavigate } from "react-router-dom";
import {
  useGetApprovedMemberLoanListQuery,
  useGetDeclinedMemberLoanListQuery,
  useGetDisbursedMemberLoanListQuery,
  useGetPaidMemberLoanListQuery,
  useGetPendingMemberLoanRequestsQuery,
} from "../../../store/member/member-loan";
import LoanManagementCard from "../modules/LoanManagementCard";
import { useUser } from "../../../hooks";
import MemberViewLoanDetailsModal from "./modals/MemberViewLoanDetailsModal";

export default function MemberLoanStatus() {
  const navigate = useNavigate();
  const user = useUser();
  const [pendingLoanPage, setPendingLoanPage] = useState(1);
  const [approvedLoanPage, setApprovedLoanPage] = useState(1);
  const [declinedLoanPage, setDeclinedLoanPage] = useState(1);
  const [disbursedLoanPage, setDisbursedLoanPage] = useState(1);
  const [completedLoanPage, setCompletedLoanPage] = useState(1);
  const [modalPage, setModalPage] = useState("");
  const [selectedLoanId, setSelectedLoanId] = useState(null);

  
  const { data: pendingLoans, isLoading: isLoadingPendingLoans } =
    useGetPendingMemberLoanRequestsQuery({
      page: pendingLoanPage,
      member_id: user?.member_id,
    });

  const { data: approvedLoans, isLoading: isLoadingApproveLoans } =
    useGetApprovedMemberLoanListQuery({
      page: approvedLoanPage,
      member_id: user?.member_id,
    });

  const { data: declinedLoans, isLoading: isLoadingDeclineLoans } =
    useGetDeclinedMemberLoanListQuery({
      page: declinedLoanPage,
      member_id: user?.member_id,
    });

  const { data: disbursedLoans, isLoading: isLoadingDisburseLoans } =
    useGetDisbursedMemberLoanListQuery({
      page: disbursedLoanPage,
      member_id: user?.member_id,
    });

  const { data: completedLoans, isLoading: isLoadingCompletedLoans } =
    useGetPaidMemberLoanListQuery(
      { page: completedLoanPage },
      { skip: !user?.member_id }
    );

  const handleViewDetails = (loanId) => {
    setSelectedLoanId(loanId);
    setModalPage("View Details Modal");
  };

  const handleViewRepaymentPlan = (loanId) => {
    navigate(`/member/loan_management/repayment/${loanId}`);
  };

  const useModal = [
    {
      name: "View Details Modal",
      component: (
        <MemberViewLoanDetailsModal
          requestId={selectedLoanId}
          setModalPage={setModalPage}
        />
      ),
    },
  ];

  const useTab = [
    {
      name: "Pending loan",
      component: (
        <LoanStatusTable
          name="pending loan"
          TableData={pendingLoans?.data?.company_loan_requests || []}
          pagination={pendingLoans?.data?.pagination}
          loading={isLoadingPendingLoans}
          setPageNumber={setPendingLoanPage}
          onViewDetails={handleViewDetails}
          onViewRepaymentPlan={handleViewRepaymentPlan}
        />
      ),
    },
    {
      name: "Approved loan",
      component: (
        <LoanStatusTable
          name="approved loan"
          TableData={approvedLoans?.data?.company_loan_requests || []}
          pagination={approvedLoans?.data?.pagination}
          loading={isLoadingApproveLoans}
          setPageNumber={setApprovedLoanPage}
          onViewDetails={handleViewDetails}
          onViewRepaymentPlan={handleViewRepaymentPlan}
        />
      ),
    },
    {
      name: "Declined loan",
      component: (
        <LoanStatusTable
          name="declined loan"
          TableData={declinedLoans?.data?.company_loan_requests || []}
          pagination={declinedLoans?.data?.pagination}
          loading={isLoadingDeclineLoans}
          setPageNumber={setDeclinedLoanPage}
          onViewDetails={handleViewDetails}
          onViewRepaymentPlan={handleViewRepaymentPlan}
        />
      ),
    },
    {
      name: "Disbursed loan",
      component: (
        <LoanStatusTable
          name="disbursed loan"
          TableData={disbursedLoans?.data?.company_loan_requests || []}
          pagination={disbursedLoans?.data?.pagination}
          loading={isLoadingDisburseLoans}
          setPageNumber={setDisbursedLoanPage}
          onViewDetails={handleViewDetails}
          onViewRepaymentPlan={handleViewRepaymentPlan}
        />
      ),
    },
    {
      name: "Completed loan",
      component: (
        <LoanStatusTable
          name="completed loan"
          TableData={completedLoans?.data?.company_loan_requests || []}
          pagination={completedLoans?.data?.pagination}
          loading={isLoadingCompletedLoans}
          setPageNumber={setCompletedLoanPage}
          onViewDetails={handleViewDetails}
          onViewRepaymentPlan={handleViewRepaymentPlan}
        />
      ),
    },
  ];
  return (
    <PageWrapper title={"Loan Status"} back>
      <section className="mt-6 space-y-6 ">
        <div className="md:w-1/2">
          <LoanManagementCard />
        </div>

        <section className="space-y-4">
          <h4 className="font-bold text-base text-[#45464E] pt-[3rem] ">
            Loan Application Status
          </h4>
          <CardComp cardClassName={"border-0 pt-[2rem] px-3"}>
            <ModalCompAdvanceUpdate
              pageName={modalPage}
              arrayComp={useModal}
              handleClose={() => setModalPage()}
              centered
              size={"xl"}
            />
            <div>
              <TabsComp
                TabArray={useTab}
                input="name"
                justifyContent={"justify-content-start"}
                tabClassName="px-0"
                TabArrayClassName="px-4"
              />
            </div>
          </CardComp>
        </section>
      </section>
    </PageWrapper>
  );
}
